import { Analysis } from 'common-spectrum';
import { oanParseHitec } from 'physical-chemistry-parser';

export function fromHitec(xls, res) {
  let analysis = new Analysis();
  const parsed = oanParseHitec(xls, res);

  let meta = {};
  for (let key in parsed.meta) {
    meta = { ...meta, ...parsed.meta[key] };
  }
  const cheminfo = {
    meta: {
      procAA: { value: meta.ProcA_A, units: 'mL/100g' },
      procAB: { value: meta.ProcA_B, units: 'mL/100g' },
      procBA: { value: meta.ProcB_A, units: 'mL/100g' },
      procBB: { value: meta.ProcB_B, units: 'mL/100g' },
      maxTorque: { value: meta.TorqueMax, units: 'mNm' },
    },
  };

  meta.cheminfo = cheminfo;

  analysis.pushSpectrum(
    {
      x: parsed.variables.x,
      y: parsed.variables.y,
    },
    {
      dataType: 'Oil Absorption Number (OAN)',
      title: meta.Meta,
      meta,
    },
  );

  return analysis;
}
